import { Box, Card, Typography } from "@mui/material";
import type { PharmaStudyRollup } from "@/api/types";
import { PharmaStudyCard } from "./PharmaStudyCard";

interface Props {
  studies: PharmaStudyRollup[];
  onEnroll: (studyId: string, locationId: string) => void;
  onUnenroll: (studyId: string, locationId: string) => void;
}

export function PharmaStudiesPanel({ studies, onEnroll, onUnenroll }: Props) {
  return (
    <Card variant="outlined" sx={{ p: 0 }}>
      <Box sx={{ p: 1.5, borderBottom: 1, borderColor: "divider", bgcolor: "action.hover" }}>
        <Typography sx={{ fontWeight: 600, fontSize: 13 }}>
          Pharma studies · {studies.length}
        </Typography>
      </Box>
      {studies.length === 0 ? (
        <Box sx={{ p: 3, textAlign: "center", color: "text.secondary", fontSize: 13 }}>
          No pharma studies running in this disease area at this site.
        </Box>
      ) : (
        studies.map((r) => (
          <PharmaStudyCard
            key={r.study.id}
            rollup={r}
            onEnroll={(locId) => onEnroll(r.study.id, locId)}
            onUnenroll={(locId) => onUnenroll(r.study.id, locId)}
          />
        ))
      )}
    </Card>
  );
}
